angular.module('zc.commonApi')

.factory 'ProjectPageDescription', ($resource, $q, BaseProjectCrudService) ->
  new BaseProjectCrudService(
    $resource
    $q
    '/api/master/projects/:projectId/page_descriptions/:id'
    'page_description'
    'page_descriptions'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/page_description.service.coffee